import { css } from 'linaria';
import { styled } from 'linaria/react';
import { breakpoints } from 'media';

export const hintButtonWrapper = css`
	display: flex;
`;

export const HintButton = styled.button`
	border: none;
	display: flex;
	padding: 0;
	margin: 0;
	cursor: pointer;
	height: fit-content;
	align-items: center;
	background: none;
`;

export const HintContentWrapper = styled.div<{ contentWidth: number }>`
	display: flex;
	flex-direction: column;
	row-gap: 12px;
	grid-column: 1/3;
	color: #fff;
	width: ${({ contentWidth }) => (contentWidth ? `${contentWidth}px` : '100%')};
	${breakpoints.to.desktop} {
		width: 100%;
	}
`;
